export default __webpack_public_path__ + "SpoqaHanSansNeo-Regular.b935041.ttf";